import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  color?: 'primary' | 'accent' | 'white' | 'blue';
}

export function LoadingSpinner({ 
  size = 'md', 
  className = '',
  color = 'primary'
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  const colorClasses = {
    primary: 'border-green-500',
    accent: 'border-orange-500',
    white: 'border-white',
    blue: 'border-blue-500',
  };

  const colorClassesBg = {
    primary: 'border-green-200',
    accent: 'border-orange-200',
    white: 'border-white/20',
    blue: 'border-blue-200',
  };

  return (
    <div className={`relative ${sizeClasses[size]} ${className}`}>
      {/* Background circle */}
      <div className={`absolute inset-0 border-2 ${colorClassesBg[color]} rounded-full`}></div>
      
      {/* Main spinning circle */}
      <div className={`absolute inset-0 border-2 border-transparent border-t-2 ${colorClasses[color]} rounded-full animate-spin`}></div>
      
      {/* Inner glow effect */}
      <div className={`absolute inset-1 border border-${colorClasses[color]}/10 rounded-full animate-pulse`}></div>
    </div>
  );
}